<template>
  <v-app> 
    <v-content>
      <Toolbar v-if="!$route.meta.hideToolbar"></Toolbar>
      <Loading></Loading>
      <transition appear mode="out-in" name="fade">
        <router-view/>
      </transition>
    </v-content>
  </v-app>
</template>

<script>
import Toolbar from '@/components/compartilhados/Toolbar'
import Loading from '@/components/compartilhados/Loading'

export default {
  name: 'App',
  components: {
    Toolbar, 
    Loading
  }
}
</script>

<style>
#app {
  background: #e6e7e8;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue